import React, { useEffect, useState } from 'react';
import {Temperature} from 'react-environment-chart';
import Thermometer from 'react-thermometer-component'
import { getAlarm } from '../../../services/alarms.service';
import _ from "lodash";
import Loader from 'react-loader-spinner';

interface SmTemperatureProps {
    value: number;
    height?: number ;
    tips?: string[];
    index: number;
}

const SmTemperature: React.FC<SmTemperatureProps> = (props: SmTemperatureProps) => {
    const [loading, setLoading] = useState(true)
    const [alarm, setAlarm] = useState<unknown>()
    useEffect(() => {
        setLoading(true)
        getAlarm(`temp${props.index}`).then((res) => {
            setLoading(false)
            setAlarm(res)
            console.log('res: ', res)
        }).catch(() => setLoading(false))
    }, [props.index])
    const getClassName = () => {
        if (alarm && _.get(alarm, 'isActive')) {
            
            if (props.value < _.get(alarm, 'valueDown')) {
                return 'd-flex justify-content-center thermo-container low-thermo-value'
            } else if (props.value > _.get(alarm, 'valueUp')) {
                return 'd-flex justify-content-center thermo-container high-thermo-value'
            }
        }

        return 'd-flex justify-content-center thermo-container correct-thermo-value'
        
    }
    if (loading) {
        return <Loader
        type="Puff"
        color="#555374"
        height={100}
        width={100}
        timeout={3000} //3 secs

    />
    }
    return (
        <div className={getClassName()}>
            {/* <Temperature value={props.value} height={props.height || 200} tips={props.tips || [' ', ' ', ' ', ' ']}/> */}
            <Thermometer
                theme="light"
                value={props.value}
                max="50"
                min="-20"
                size="normal"
                height="200"
                reverseGradient={true}
                />
        </div>
    )
}

export default SmTemperature;

/**
 * thermometer__bg-color
 * linear-gradient(#2196F3, #8BC34A, #f44336);
 * 
 * 
 */